import DOMPurify from 'dompurify';

const SafeHtml = ({ html, ...props }) => {
  const sanitizedHtml = DOMPurify.sanitize(html);

  return <div {...props} dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />;
};

export default SafeHtml;
